export default __webpack_public_path__ + "static/media/beam.60321589.png";